var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemove = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.667 4.333h10.667V13a.667.667 0 0 1-.667.667H2.334A.666.666 0 0 1 1.667 13V4.333Zm1.334 1.334v6.666h8V5.667H3ZM5 7h1.333v4H5.001V7Zm2.666 0h1.334v4H7.667V7Zm-4-4.667V1a.667.667 0 0 1 .667-.667h5.333a.667.667 0 0 1 .667.667v1.333h3.333v1.334H.334V2.333h3.333Zm1.334-.666v.666h4v-.666H5Z"
})));
export default SvgRemove;